export default __webpack_public_path__ + "static/media/Vazir-Thin.3fc2bef7.eot";